import parse from 'html-react-parser';
import {
    FieldWrapper,
} from "@progress/kendo-react-form";
import {
    Label,
} from "@progress/kendo-react-labels";

function TextFieldWrapper({
    title = "",
    boldTitle = false,
    text = "",
    textIsLink = false,
}) {

    return (
        <FieldWrapper className="k-d-grid">
            <Label className="k-form-label font-size-md" style={{
                fontWeight: boldTitle ? "700" : "normal"
            } }>
                {parse(title) }:
            </Label>
            <div className="k-form-field-wrap text-truncate">
                {
                    textIsLink ? 
                        <a className="phone-link" href={`tel:${text}`}>{text}</a>
                    :
                    text
                }
            </div>
        </FieldWrapper>
    );
}

export default TextFieldWrapper; 
